import React from 'react'
import CollectionsListTable from './CollectionsListTable'
import EarningsReport from './EarningsReport'
import BillableCareTable from './BillableCareTable'
import GoxListModal from './GoxListModal'


function modelContentController(props) {
    const { type, collectionGroupByCategory } = props
    switch (type) {
        case 'earnings':
            return <EarningsReport {...props} />
        case 'billableCare':
        case 'HYNbillableCare':
            return <BillableCareTable {...props} />
        case 'collectionsBillableCare':
        case 'tedCollections':
            return <CollectionsListTable  {...props} groupBy={collectionGroupByCategory} />

        case 'collectionList':
        case 'collectionsHynList':
            return <CollectionsListTable  {...props} groupBy={collectionGroupByCategory} />
        case 'goxBillableCare':
            return <GoxListModal  {...props} />
        default:
            return ' Blank Report'
    }
}

function Content(props) {
    const content = modelContentController(props)
    return (
        <div>
            {content}
        </div>
    )
}

export default Content